import { ISO7064computeWithoutCheck } from './utils/iso-7064';

const FORMAT_ISVALID = /^[0-9A-Z]{18}[0-9]{2}$/;

export function checkLeiValidity(value: string | undefined | null) {
  if (value === '' || !value) {
    return false;
  }

  const upperValue = value.toUpperCase();

  if (!upperValue.match(FORMAT_ISVALID)) {
    return false;
  }

  return ISO7064computeWithoutCheck(upperValue) === 1;
}
